export default __webpack_public_path__ + "static/media/CashIcon.50f1ef37.svg";